// extracted by mini-css-extract-plugin
export default {"container":"container_kod+Q","img":"img_tSETx","rightBlock":"rightBlock_1G3aE"};